import React, { useState } from 'react';
import '../../entrydoor.css';

const ExteriorDoor = ({ value, onChange, label = 'Exterior Door:', disabled = false }) => {
    const [selectedExteriorDoor, setSelectedExteriorDoor] = useState(value || "White");

    const handleExteriorDoorChange = (e) => {
        setSelectedExteriorDoor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="ExteriorDoor">{label}</label>
            <select
                disabled={disabled}
                id="ExteriorDoor"
                value={selectedExteriorDoor}
                onChange={handleExteriorDoorChange}
            >
                <option value="">Select an option</option>
                <option value="White" >{selectedExteriorDoor  === "White" ? "White ✔" :  "White" }</option>
                <option value="Gentek">{selectedExteriorDoor === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default ExteriorDoor;
